import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { DataGrid, GridRowSelectionModel } from '@mui/x-data-grid';

import { StoredDeviceLog } from '../../interfaces';
import { storedColumns } from './columns';

export const MIN_LOGS_TO_DOWNLOAD = 1;

interface Props {
    logs: StoredDeviceLog[];
    loading: boolean;
    selectedLogIds: GridRowSelectionModel;
    onSelectionChange: (selection: GridRowSelectionModel) => void;
    downloading: boolean;
    onDownload: () => void;
}

export const StoredLogsGrid = ({
    logs,
    loading,
    selectedLogIds,
    onSelectionChange,
    downloading,
    onDownload,
}: Props) => {
    const canDownload = !downloading && selectedLogIds.length >= MIN_LOGS_TO_DOWNLOAD;

    return (
        <>
            <Box mb={1}>
                <strong>Logs available in the cloud</strong>
            </Box>
            <Box display="flex" gap={2} alignItems="center" mb={1} flexWrap="wrap">
                <Button
                    variant="outlined"
                    startIcon={downloading ? <CircularProgress size={15} /> : <DownloadIcon />}
                    disabled={!canDownload}
                    onClick={onDownload}
                >
                    Download selected logs
                </Button>
                <Box color="text.secondary">
                    {selectedLogIds.length > 0
                        ? `Selected logs: ${selectedLogIds.length}`
                        : `Select at least ${MIN_LOGS_TO_DOWNLOAD} log for download`}
                </Box>
            </Box>
            <Box height={340}>
                <DataGrid
                    rows={logs}
                    columns={storedColumns}
                    loading={loading}
                    getRowId={(row) => row.logId}
                    checkboxSelection
                    disableRowSelectionOnClick
                    rowSelectionModel={selectedLogIds}
                    onRowSelectionModelChange={onSelectionChange}
                />
            </Box>
        </>
    );
};
